export function createNaverMessageHandler({
    handleSocialPersistentLogin,
    processSocialLogin,
    setLoading,
    openAlert
}) {
    return async (event) => {
        if (!event || event.origin !== window.location.origin) {
            return;
        }

        if (event.data && event.data.type === "NAVER_LOGIN_SUCCESS") {
            const profile = event.data.userProfile;
            if (!profile || !profile.provider) {
                setLoading(false);
                openAlert("네이버 로그인 응답 형식이 올바르지 않습니다.", "로그인 실패");
                return;
            }
            try {
                const currentUser = await handleSocialPersistentLogin(profile);
                await processSocialLogin(currentUser, profile);
            } catch (e) {
                console.error(e);
                openAlert("로그인 처리 중 오류가 발생했습니다.", "오류");
            } finally {
                setLoading(false);
            }
            return;
        }

        if (event.data && event.data.type === "NAVER_LOGIN_FAILURE") {
            console.warn("Naver Login Failed Message Received:", event.data.error);
            setLoading(false);
            openAlert("네이버 로그인에 실패했습니다. 다시 시도해주세요.", "로그인 실패");
        }
    };
}

export async function runNaverRedirectCheck({
    handleNaverCallback,
    handleSocialPersistentLogin,
    processSocialLogin,
    setIsNaverCallback,
    setLoading,
    openAlert
}) {
    if (!window.location.href.includes("access_token")) {
        return;
    }

    const profile = await handleNaverCallback();

    if (window.opener) {
        console.log("[Callback] Popup detected, stopping repetitive processing.");
        setIsNaverCallback(false);
        setLoading(false);
        return;
    }

    if (profile) {
        try {
            const currentUser = await handleSocialPersistentLogin(profile);
            await processSocialLogin(currentUser, profile);
            window.history.replaceState({}, document.title, "/");
        } catch (e) {
            console.error(e);
            openAlert("로그인 처리 중 오류가 발생했습니다.", "오류");
        }
    }
    setIsNaverCallback(false);
    setLoading(false);
}
